import { createSlice, current } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { showSuccess } from '../../app/utils/sweetAlert';
// import { showSuccess } from "../../app/utils/sweetAlert";
import {
	addKey,
	addLanguage,
	editKey,
	editLanguage,
	getFirstLanguage,
	getLanguagesListWithPagenation,
	getSampleCSV,
	getSecondLanguage
} from '../apis/languageAPIs';
interface CommonState {
	FirstLanguage: Array<any>;
	FirstLanguageArr: Array<any>;
	currentPage: number;
	count: number;
	loading: boolean;
	secondLanguage: Array<any>;
	listForRander: Array<any>;
	languageListing: Array<any>;
	currentPageInLanguageList: number | string;
	countInLanguageList: number;
	existingLanguage: Array<any>;
	secondLanguageSAFE: Array<any>;
	secondaryJson: any;
}

const initialState: CommonState = {
	FirstLanguage: [],
	secondLanguage: [],
	secondLanguageSAFE: [],
	FirstLanguageArr: [],
	currentPage: 1,
	count: 0,
	secondaryJson: {},
	loading: false,
	listForRander: [],
	languageListing: [],
	currentPageInLanguageList: 1,
	countInLanguageList: 0,
	existingLanguage: []
};

const languageSlice = createSlice({
	name: 'common',
	initialState,
	reducers: {
		storeGetLanguages(state, action) {
			state.FirstLanguage = action.payload;
		},
		handlePagination(state, action: any) {
			state.currentPage = action.payload;
		},
		storeFirstLangArray(state, action) {
			state.FirstLanguageArr = action.payload;
		},
		setCountInLanguageSlice(state, action: any) {
			state.count = action.payload;
		},
		handleRenderListing(state, action: any) {
			state.listForRander = action.payload;
		},
		handlePaginationInLanguageListing(state, action: any) {
			state.currentPageInLanguageList = action.payload;
		},
		ExistingLanguageFormate(state, action: any) {
			state.existingLanguage = action.payload;
		},
		setSecondaryJson(state, action: any) {
			state.secondaryJson = action.payload;
		},
		modifySecondLanguage(state, action: any) {
			state.secondLanguage = {
				...current(state.secondLanguage),
				[action.payload.key]: {
					...current(state.secondLanguage[action.payload.key]),
					[action.payload.device_type]: action.payload.data
				}
			};
		},
		discardChangeInKey(state) {
			state.secondLanguage = current(state.secondLanguageSAFE);
		}
	},
	extraReducers: builder => {
		builder.addCase(getFirstLanguage.pending, state => {
			state.loading = true;
		});
		builder.addCase(getFirstLanguage.fulfilled, (state, action: any) => {
			state.FirstLanguage = action.payload.data;
			state.loading = false;
		});
		builder.addCase(getFirstLanguage.rejected, state => {
			state.loading = false;
		});
		builder.addCase(getSecondLanguage.pending, state => {
			state.loading = true;
		});
		builder.addCase(getSecondLanguage.fulfilled, (state, action: any) => {
			state.secondLanguage = action.payload.data;
			state.secondLanguageSAFE = action.payload.data;
			state.loading = false;
		});
		builder.addCase(getSecondLanguage.rejected, state => {
			state.loading = false;
		});
		builder.addCase(getSampleCSV.pending, () => {
			// state.loading = true;
		});
		builder.addCase(getSampleCSV.fulfilled, () => {
			// state.loading = false;
		});
		builder.addCase(getSampleCSV.rejected, () => {
			// state.loading = false;
		});
		builder.addCase(addKey.pending, state => {
			state.loading = true;
		});
		builder.addCase(addKey.fulfilled, (state, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(addKey.rejected, state => {
			state.loading = false;
		});
		builder.addCase(editKey.pending, state => {
			state.loading = true;
		});
		builder.addCase(editKey.fulfilled, (state, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(editKey.rejected, state => {
			state.loading = false;
		});
		builder.addCase(editLanguage.pending, state => {
			state.loading = true;
		});
		builder.addCase(editLanguage.fulfilled, (state, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(editLanguage.rejected, state => {
			state.loading = false;
		});
		builder.addCase(addLanguage.pending, state => {
			state.loading = true;
		});
		builder.addCase(addLanguage.fulfilled, state => {
			state.loading = false;
		});
		builder.addCase(addLanguage.rejected, state => {
			state.loading = false;
		});
		builder.addCase(getLanguagesListWithPagenation.rejected, state => {
			state.loading = false;
		});
		builder.addCase(getLanguagesListWithPagenation.pending, state => {
			state.loading = true;
		});
		builder.addCase(
			getLanguagesListWithPagenation.fulfilled,
			(state, action: any) => {
				// const { list, count: { count } } = action.payload.data[0]
				if (action.payload?.data?.list) {
					state.languageListing = action.payload?.data?.list;
					state.countInLanguageList = action?.payload?.data?.count?.count;
				}
				state.loading = false;
			}
		);
	}
});
export const {
	storeGetLanguages,
	storeFirstLangArray,
	setSecondaryJson,
	handlePagination,
	setCountInLanguageSlice,
	handleRenderListing,
	handlePaginationInLanguageListing,
	modifySecondLanguage,
	discardChangeInKey
} = languageSlice.actions;
export default languageSlice.reducer;
